import image1 from "../assets/t-image1.png";
import image2 from "../assets/t-image2.jpg";
import image3 from "../assets/t-image3.jpg";

export const testimonialsData = [
  {
    image: image1,
    review:
      "I made the right choice by choosing the Fitclub and by choosing the right plan and program I already achieved my ideal body!",
    name: 'MATHEW HENDRICKSON',
    status : 'ENTREPRENEUR'
  },
  {
    image: image2,
    review: 'I started Fitness Within’s Remote Coaching over 2 months ago. I have lost some weight, gotten on a healthy exercise and meal schedule and feel great about myself. ',
    name: 'JOHN KEVIN',
    status: 'COACH'
  },
  {
    image : image3,
    review:' I will have been training at Fitness Within 3 years December 2020. Since working out here I am stronger and in better shape than at any other time in my life. I find every class and every trainer are different but always super challenging',
    name: 'FRANKLIN',
    status: "CUSTOMER"
  }
];
